if (!customElements.get('rb-delivery')) {
  class RechargeDelivery extends HTMLElement {
    connectedCallback() {
      this.recharge = {
        switch: null,
        checkbox: null,
        select: null,
      }

      document.addEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.addEventListener("recharge:progress", this.onProgressChange.bind(this));
      document.addEventListener("recharge:delivery:update", this.onDeliveryUpdate.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.removeEventListener("recharge:progress", this.onProgressChange.bind(this));
      document.removeEventListener("recharge:delivery:update", this.onDeliveryUpdate.bind(this));
    }

    onRechargeReady() {
      this.hidden = false;

      if(this.checkbox) {
        this.checkbox.removeEventListener('click', this.onCheckbox.bind(this));  
      }
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.checkbox.addEventListener('click', this.onCheckbox.bind(this));

      if(this.switches) {
        this.switches.forEach(element => element.removeEventListener('click', this.onSwitch.bind(this)));  
      }
      this.switches = this.querySelectorAll('[for="rb-configuration-delivery"]');
      this.switches.forEach(element => element.addEventListener('click', this.onSwitch.bind(this)));

      if(this.select) {
        this.select.removeEventListener('change', this.onSelectChange.bind(this));
      }
      this.select = this.querySelector('select');
      this.select.addEventListener('change', this.onSelectChange.bind(this));

      setTimeout(() => {
        this.recharge.checkbox = document.querySelector('.rb-subscribe-and-save-container .rb-switch input[type="checkbox"]');
        this.recharge.select = document.querySelector('.rb-frequency select');

        //Restore saved delivery config
        this.restoreFromStorage();

        //Sync delivery from active button on initial load if nothing was restored
        const saved = Shopify.LocalStorage.get('rechargebundle_delivery');
        if(!saved || !saved.frequency) {
          const activeButton = document.querySelector('rb-button[active][delivery]');
          if(activeButton) {
            this.onDeliveryUpdate({ detail: activeButton.getAttribute('delivery') });
          }
        }
      }, 100)
    }

    get active() {
      return this.getAttribute('active') ? true : false
    }

    set active(flag) {
      if(flag) {
        this.setAttribute('active', true)
        this.select.removeAttribute('hidden');
      } else {
        this.removeAttribute('active');
        this.select.hidden = true
      }
    }

    get hidden() {
      return this.getAttribute('hidden') ? true : false
    }

    set hidden(flag) {
      if(flag) {
        this.setAttribute('hidden', true)
      } else {
        this.removeAttribute('hidden');
      }
    }

    resetSelect() {
      const index = 1;

      //Set Value based on Title
      const options = this.recharge.select.querySelectorAll('option');

      if(!options[index]) {
        return console.error('resetSelect')
      }
      
      options[index].selected = true;
      this.select.selectedIndex = index;
    }

    updateSelect() {
      if(!this.recharge.select || !this.select) {
        return;
      }

      const value = this.select.value;

      //Set Value based on Title
      const options = this.recharge.select.querySelectorAll('option');

      if(!options[value] || !value) {
        return console.error('onSelectChange')
      }
      
      options[value].selected = true;

      //SelectedIndex
      this.recharge.select.selectedIndex = value;
    }

    updateDelivery() {
      if(!this.recharge.checkbox || !this.checkbox) {
        return;
      }

      this.recharge.checkbox.checked = this.checkbox.checked
    }

    saveToStorage() {
      Shopify.LocalStorage.set('rechargebundle_delivery', {
        active: this.active,
        frequency: this.select.value,
        timestamp: Date.now(),
      });
    }

    restoreFromStorage() {
      const saved = Shopify.LocalStorage.get('rechargebundle_delivery');
      if(!saved) return;

      //Make sure its not older than 5 Minutes
      if(Date.now() - saved.timestamp > 5 * 60 * 1000) {
        Shopify.LocalStorage.remove('rechargebundle_delivery');
        return;
      }

      if(saved.active) {
        this.active = true;
        this.checkbox.checked = true;
        this.recharge.checkbox.checked = true;
      }

      if(saved.frequency) {
        this.select.value = saved.frequency;
        this.updateSelect();
      }
    }

    onCheckbox() {
      this.active = this.checkbox.checked;

      //Update Target
      this.recharge.checkbox.checked = this.active;
      this.saveToStorage();
    }

    onSwitch() {
      this.active = !this.active;
      this.checkbox.checked = this.active;

      //When re-activating the subscription, sync the frequency from
      //the active variant button instead of resetting to the default
      //(2 weeks). When deactivating, fall back to the default.
      if(this.active) {
        const activeButton = document.querySelector('rb-button[active][delivery]');
        if(activeButton) {
          this.onDeliveryUpdate({ detail: activeButton.getAttribute('delivery') });
        } else {
          this.resetSelect();
        }
      } else {
        this.resetSelect();
      }

      //Update Dlivery
      this.updateDelivery();

      //Trigger event
      this.recharge.checkbox.dispatchEvent(new Event('change'));

      //Save
      this.saveToStorage();
    }

    onSelectChange(event) {
      const { value } = event.target;

      const options = this.recharge.select.querySelectorAll('option');

      if(!options[value]) {
        return console.error('onSelectChange')
      }

      options[value].selected = true;

      //Selected Index
      this.recharge.selectedIndex = value;

      //Dispatch one event to prevent weird double element changes
      this.recharge.select.dispatchEvent(new Event('change'));

      //Save
      this.saveToStorage();
    }

    onProgressChange() {
      //Delivery
      this.updateDelivery();

      //Select
      this.updateSelect();

      //Dispatch one event to prevent weird double element changes
      //this.recharge.select.dispatchEvent(new Event('change'));
    }

    onDeliveryUpdate(event) {
      if(!event || !event.detail || !this.recharge.select) {
        return console.error('onDeliveryUpdate', 'missing values');
      }

      //Pushing a frequency into ReCharge re-activates the subscription there,
      //so skip it while the subscription is switched off — the frequency is
      //synced from the active variant button in onSwitch when it comes back on.
      if(!this.active) {
        return;
      }

      const label = event.detail;

      //Find options
      const options = Array.from(this.select.querySelectorAll('option'));
      const option = options.find(option => option.innerText === label)
      if(!option) {
        return;
      }

      this.select.value = option.value;

      //Update Progress
      this.onProgressChange();

      //Select
      this.recharge.select.dispatchEvent(new Event('change'));
    }

    dispatchEvent() {
      document.dispatchEvent(new CustomEvent('recharge:delivery', {
        detail: {
          id: this.id,
          title: this.title,
          price: this.price
        }
      }))
    }
  }
  customElements.define('rb-delivery', RechargeDelivery);
}